import { Injectable } from "@angular/core";
import { LorenContentTypes } from "../../../../shared/services/loren-http-service/enums/loren-content-types.enums";
import { LorenAsset } from "../../../loren-assets/interfaces/loren-asset.interface";
import { DateRange, evaluateDateRange } from "../../../../common/forms/period-select/period-select.component";

@Injectable({
  providedIn: "root",
})
export class LorenReportsUtilsService {
  static getExportFilename(
    selectedAssets: LorenAsset[],
    period: DateRange,
    contentType: LorenContentTypes = LorenContentTypes.EXCEL
  ) {
    const [from, to] = evaluateDateRange(period);

    return `${selectedAssets.map((x) => x.name).join(", ")} ${
      from.toString().split("T")[0]
    } ${to.toString().split("T")[0]}.${contentType}`;
  }

  static getDevicesReportFilename() {
    return `${new Date().toDateString()}-devices-report.${
      LorenContentTypes.EXCEL
    }`;
  }
}
